import React from 'react';

import ClassAImg from '@/assets/great/class-a.jpg';
import ComputerImg from '@/assets/great/computer.jpg';
import SuntreesImg from '@/assets/great/sun-trees.jpg';

import ResponsiveImage from '../utility/ResponsiveImage/ResponsiveImage';
import css from './HeroImages.module.css';

const Hero = () => (
  <div className={css.images}>
    <div className={css.image1}>
      <ResponsiveImage src={ClassAImg.src} alt="" priority={true} withFetchPriority="high" />
    </div>
    <div className={css.image2}>
      <ResponsiveImage src={SuntreesImg.src} alt="" priority={true} withFetchPriority="high" />
    </div>
    <div className={css.image3}>
      <ResponsiveImage src={ComputerImg.src} alt="" priority={true} withFetchPriority="high" />
    </div>
  </div>
);

export default Hero;
